import { IRegInvestStore } from './createStore'

export const contextSelector = (store: IRegInvestStore) => store.context
export const appSelector = (store: IRegInvestStore) => store.app
export const amountSelector = (store: IRegInvestStore) => store.amount
export const savingsSelector = (store: IRegInvestStore) => store.savings
